document.addEventListener("click", function (e) {
    var shareBtn = e.target.closest(".share-copy-btn");
    if (!shareBtn) return;

    var card = shareBtn.closest(".loop-card-wrapper");
    var url;

    if (card) {
        var dataUrl = card.getAttribute("data-post-url");
        var link = card.querySelector(".lees-meer-btn a.elementor-button");

        if (dataUrl) {
            url = dataUrl;
        } else if (link) {
            url = link.href;
        }
    }

    if (!url) {
        url = window.location.href;
    }

    copyToClipboard(url, shareBtn);
});
function copyToClipboard(text, triggerEl) {
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
            .writeText(text)
            .then(function () {
                showCopiedFeedback(triggerEl);
            })
            .catch(function (err) {
                console.error(err);
                fallbackCopy(text, triggerEl);
            });
    } else {
        fallbackCopy(text, triggerEl);
    }
}

function fallbackCopy(text, triggerEl) {
    var textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
        document.execCommand("copy");
        showCopiedFeedback(triggerEl);
    } catch (err) {
        console.error(err);
    }

    document.body.removeChild(textarea);
}

function showCopiedFeedback(triggerEl) {
    triggerEl.classList.add("is-copied");
    setTimeout(function () {
        triggerEl.classList.remove("is-copied");
    }, 1500);
}
